import axios from 'axios';

export const verifyAccount = (token) => {
  const encodedToken = encodeURIComponent(token);
  return axios.post(`/auth/email/verify?token=${encodedToken}`);
};

export const verifyEmailChange = (userToken, emailToken) => {
  return axios.post('/auth/email/verifyEmailChange', {
    userToken,
    emailToken,
  });
};
